import { warn } from "console";


export const en = {
  common: {
    cancel: "Cancel",
    delete: "Delete",
    generate: "Generate",
    invalid: "Invalid File",
    loading: "Loading...",
    preview: "Preview",
    reset: "Change Password",
    save: "Save",
  },
  auth: {
    copyright: "© 2026 Spotlight Manager is a product of Redlof Medien GmbH & Co. KG, Ansbach, Germany",
    email: "Email",
    legal: "Corporate information",
    login: "Sign in",
    logout: "Logout",
    privacy: "Privacy notice",
    pwd: "Password",
    welcome: "Welcome, {name}!",
  },
  dd:{
    All: "All",
    Approved: "Approved",
    AwaitingApproval: "Pending",
    Denied: "Denied",
    Editing: "Editing",
    Select: "Select...",
  },
  playlist:{
    bookings: "Bookings",
    customer: "Customer",
    duration: "Duration", 
    durationBooked: "Booked", 
    name: "Name",
    orderBegin: "Start Date",
    orderEnd: "End Date", 
    rotation: "Rotation", 
  },
  ui: {
    0:"A",
    1:"B",
    2:"C",
    active: "Active",
    addLogo: "Click to add Logo",
    address: "Address",
    addSite: "Add Site",
    admin: "Administrator",
    allMediaFilesNeedUpload: "All media formats need to be uploaded.",
    approve: "Approve",
    book: "Book",
    bookedlength: "Booked Length",
    bookingInfo: "Booking Info",
    bookinginfo: "Booking Info",
    bookings: "Bookings",
    changeDate: "Modification date",
    actions: "Actions",
    dashboard: "Dashboard",
    cell: "Cell",
    choose: "Please choose:",
    city: "City",
    company: "Company",
    companyinfo: "Company Info",
    companysearch: "Search for company...",
    confirmdeletebooking: "Do you want to delete this booking?",
    container: "Container",
    copybooking: "Apply also for the following sites:",
    customer: "Company",
    customers: "Companies",
    deletebooking: "Delete Booking",
    deny: "Deny",
    duration: "Dauer",
    editor: "Template Editor",
    email: "Email",
    enddate: "End Date",
    error: "Error",
    excludeorders: "Exclude Past Orders",
    failedsave: "Error: ",
    fax: "Fax",
    fileTooLarge: "File size exceeds 20MB limit.",
    fileWarning: "Please not: File size should not exceed 10MB.",
    firstname: "First Name",
    foldername: "Folder Name for Uploads",
    format: "Format",
    lastname: "Last Name",
    line: "Line",
    loop: "Loop",
    looplength: "Loop Length",
    media: "Media",
    mediaNotAvailableYet: "Media is being converted. This may take a few minutes. Please try again later.",
    menu: "Menu",
    name: "Name",
    neededForOrders: "Needed for orders",
    nomediaforaspectratio: "This format is not supported.",
    note: "Note",
    noTemplates:"No templates have been created for you.",
    occupancy: "Occupancy",
    order: "Order",
    orderinfo: "Order Details",
    orderLength: "Duration/Length",
    orderlength: "Order Length",
    orders: "Orders",
    page: "Page",
    phone: "Phone",
    playlist: "Playlist",
    playlists: "Playlists",
    pleaseNote: "Please note:",
    role: "Role",
    rotation: "Rotation",
    searchorder: "Search for order...",
    searchspot: "Search for spot...",
    select: "",
    selectFile: "Select File",
    selectTemplate: "Select Template",
    site: "Site",
    spot: "Spot",
    spotinfo: "Spot Details",
    spotpersiteerror: "The spot could not be booked for the following sites:", 
    spots: "Spots",
    startdate: "Start Date",
    status_1: "Editing",
    status_2: "Awaiting Approval",
    status_3: "Approved",
    status_4: "Denied",
    status_active: "Active",
    status: "Status",
    street: "Street",
    submitForApproval: "Submit for Approval",
    templates: "Templates",
    type: "Type",
    undoApproval: "Change Spot",
    undoApprovalText: "Warning: This will make the spot editable and it will need to be approved again. During this time the spot will not be played. Do you want to proceed?",
    uploadFile: "Upload File",
    username: "User Name",
    usernameInfo: "User Name",
    users: "Users",
    usersActiveOnly: "active only",
    userAutoApprove: "Approve spots automatically",
    userInfo: "User Info",
    userPwd: "Password",
    userSearch: "Search for User...",
    viewspot: "View Spot",
    warning: "Warning",
    website: "Website",
    zip: "Zip",
    createspot: "Create Spot",
    width: "Width",
    height: "Height",
    notPossible: "There are no active orders. Spots cannot be created.",
    selectCustomer: "Please select a customer from the list.",
    more: "More",
    datechanged: "Date Changed",
   
  }
} as const;